import React, { useEffect, useMemo, useRef, useState } from "react";
import NavBar from "../commonComponents.jsx/NavBar.jsx";
import { motion, AnimatePresence } from "framer-motion";
import Sidebar from "../components/SideBar.jsx";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import LocationDropdown from "../commonComponents.jsx/LocationDropdown.jsx";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import CommonFooter from "../commonComponents.jsx/CommonFooter.jsx";
import MultipleLocationSuperMarketModal from "../components/MultipleLocationSuperMarketModal.jsx";
import AIAssistant from "../components/AIAssistant.jsx";
import "highcharts/highcharts-3d";
import down from "../images/address.png";
import noP from "../images/np.png";
import DatePickerWithInput from "../commonComponents.jsx/DatePickerWithInput.jsx";
import toast, { Toaster } from "react-hot-toast";

ChartJS.register(ArcElement, Tooltip, Legend);

const DayCloseCash = () => {
  const [isSideBar, setIsSideBar] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const today = new Date().toISOString().split("T")[0];

  const sevenDaysBefore = new Date();
  sevenDaysBefore.setDate(sevenDaysBefore.getDate() - 7);

  const [fromDate, setFromDate] = useState(
    sevenDaysBefore.toISOString().split("T")[0],
  );

  const [toDate, setToDate] = useState(today);
  const [pending, setPending] = useState();
  const [apply, setApply] = useState(0);
  const [filterLocations, setFilterLocations] = useState([]);
  const dropdownRef = useRef(null);
  const filterRef = useRef(null);
  const [page, setPage] = useState(1);
  const pageSize = 24;

  const [isLocationModalOpen, setIsLocationModalOpen] = useState(false);
  const [Datas, setData] = useState({
    summary: [],
    locationWise: [],
  });
  const [selectedLocationID, setSelectedLocationID] = useState(null);
  const [multipleLocation, setMultipleLocations] = useState([]);



  const handleLocationSubmit = ({ summary, locationWise, pending }) => {
    setData({ summary, locationWise, pending });
  };

  useEffect(() => {
    const locationID = JSON.parse(sessionStorage.getItem("selectedLocation"));
    const locationList = JSON.parse(
      sessionStorage.getItem("locations") || "[]",
    );
    setSelectedLocationID(locationID);
    setMultipleLocations(locationList);
  }, []);

  const clientid = sessionStorage.getItem("clientId");
  const filteredLocationsId = filterLocations.map((item) => item.locationID);
  const locations = JSON.parse(sessionStorage.getItem("locations") || "[]");

  const adminInfo = JSON.parse(sessionStorage.getItem("adminInfo") || "{}");
  useEffect(() => {
    const hasShownModal = sessionStorage.getItem(
      "hasShownMultipleLocationModal",
    );
    const adminInfo = JSON.parse(sessionStorage.getItem("adminInfo") || "null");

    if (
      !hasShownModal &&
      adminInfo &&
      Array.isArray(adminInfo.multiple_location) &&
      adminInfo.multiple_location.length > 0
    ) {
      setIsLocationModalOpen(true);
      sessionStorage.setItem("hasShownMultipleLocationModal", "true");
    }
  }, []);

  const fetchLocations = async ({ queryKey }) => {
    const [, { clientid, locations }] = queryKey;

    const token = sessionStorage.getItem("token");

    if (!token || !clientid || locations.length === 0) {
      throw new Error("Missing required parameters");
    }

    const requestBody = {
      clientid: clientid,
      dataurl: "/api/Location",
      type: "get",
      subdata: {
        loations: locations,
      },
    };

    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_API_URL}/clients/summarydetails`,
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );

    return response.data.result;
  };

  const shouldFetchLocations = adminInfo?.multiple_location?.length === 0;

  const { data: locationData = [] } = useQuery({
    queryKey: ["locations", { clientid, locations }],
    queryFn: fetchLocations,
    enabled: shouldFetchLocations && !!clientid && locations.length > 0,
    staleTime: 1000 * 60 * 5,
  });

  const getDateRangeDiff = (fromDate, toDate) => {
    if (!fromDate || !toDate) return null;
    const from = new Date(fromDate);
    const to = new Date(toDate);
    return (to.getTime() - from.getTime()) / (1000 * 60 * 60 * 24);
  };

  const isDateRangeValid = useMemo(() => {
    const diff = getDateRangeDiff(fromDate, toDate);
    if (diff === null) return false;
    return diff >= 0 && diff <= 7;
  }, [fromDate, toDate]);

  const validateDateRange = () => {
    const diff = getDateRangeDiff(fromDate, toDate);

    if (diff === null) return false;

    if (diff < 0) {
      toast.error("To Date cannot be before From Date");
      return false;
    }
    if (diff > 7) {
      toast.error("From Date and To Date must be within 7 days");
      return false;
    }
    return true;
  };

  const fetchCashCloseList = async ({ queryKey }) => {
    const [, { clientid, fromDate, toDate }] = queryKey;

    const token = sessionStorage.getItem("token");

    if (!token || !clientid || !fromDate || !toDate) {
      throw new Error("Missing required parameters");
    }

    const locationID =
      Array.isArray(filteredLocationsId) && filteredLocationsId.length > 0
        ? filteredLocationsId[0]
        : locationData[0]?.locationID;

    const requestBody = {
      clientid,
      type: "POST",
      dataurl: "/api/Sales/DayCloseCashDiff",
      subdata: {
        loation: locationID,
        fromDate: new Date(fromDate).toISOString(),
        toDate: new Date(toDate).toISOString(),
      },
    };

    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_API_URL}/clients/summarydetails`,
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );

    return response.data.result;
  };

  const {
    data: dayCloseCashData,
    isLoading,
    isFetching,
    isFetched,
    refetch,
  } = useQuery({
    queryKey: [
      "products-list",
      {
        clientid,
        apply,
        fromDate,
        toDate,
      },
    ],
    queryFn: fetchCashCloseList,
    enabled:
      !!clientid &&
      adminInfo?.multiple_location?.length === 0 &&
      locationData.length > 0 &&
      isDateRangeValid,
    staleTime: 1000 * 60 * 5,
  });


  useEffect(() => {
    if (!fromDate || !toDate) return;
    const diff = getDateRangeDiff(fromDate, toDate);
    if (diff === null) return;

    if (diff < 0) {
      toast.error("To Date cannot be before From Date");
    } else if (diff > 7) {
      toast.error("From Date and To Date must be within 7 days");
    }
  }, [fromDate, toDate]);

  const fetchMultipleLocations = async ({ queryKey }) => {
    const [, { selectedLocationID, multipleLocation }] = queryKey;

    const token = sessionStorage.getItem("token");

    if (!token || !selectedLocationID || locations.length === 0) {
      throw new Error("Missing required parameters");
    }

    const requestBody = {
      id: selectedLocationID,
      dataurl: "/api/Location",
      type: "get",
      subdata: {
        loations: multipleLocation,
      },
    };

    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_API_URL}/clients/multipleLocations-summarydetails`,
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );

    return response.data.result;
  };

  const { data: multipleLocations = [], refetch: refetchLocation } = useQuery({
    queryKey: ["multi-location-list", { selectedLocationID, locations }],
    queryFn: fetchMultipleLocations,
    enabled:
      !!selectedLocationID &&
      locations.length > 0 &&
      adminInfo?.multiple_location.length >= 1,
    staleTime: 1000 * 60 * 5,
  });

  const locationDatas =
    Datas.summary.length === 0 && Datas.locationWise.length === 0
      ? locationData
      : multipleLocations;

  const clientData = JSON.parse(
    sessionStorage.getItem("clientSettings") || "null",
  );

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
      if (filterRef.current && !filterRef.current.contains(event.target)) {
        setIsFilterOpen(false);
      }
    };

    if (isSideBar || isDropdownOpen || isFilterOpen) {
      document.addEventListener("mousedown", handleClickOutside);
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.body.style.overflow = "auto";
    };
  }, [isSideBar, isDropdownOpen, isFilterOpen]);

  const getPageNumbers = (current, total) => {
    const pages = [];
    const delta = 1;
    for (let i = 1; i <= total; i++) {
      if (
        i === 1 ||
        i === total ||
        (i >= current - delta && i <= current + delta)
      ) {
        pages.push(i);
      } else if (pages[pages.length - 1] !== "...") {
        pages.push("...");
      }
    }
    return pages;
  };

  const handleApplyFilter = () => {
    setIsFilterOpen(false);

    if (!validateDateRange()) return;

    Datas.summary.length === 0 && Datas.locationWise.length === 0
      ? refetch()
      : refetchLocation();
  };

  const handleResetFilter = () => {
    setFromDate(today);
    setToDate(today);
    setFilterLocations([]);
  };

  const fmt = (val) => val?.toFixed(2);

  useEffect(() => {
    if (locationData.length === 0) return;
    setFilterLocations([locationData[0]]);
  }, [locationData]);

  const toggleLocationSelection = (location) => {
    setFilterLocations((prev) => {
      const isAlreadySelected = prev.some(
        (l) => l.locationID === location.locationID,
      );
      return isAlreadySelected ? [] : [location];
    });
  };

  const getDisplayText = (locations) => {
    if (locations.length === 0) {
      return "All Locations";
    }

    return locations.length > 2
      ? `${locations[0].locationName}, +${locations.length - 1} more`
      : locations.map((location) => location.locationName).join(", ");
  };

  return (
    <>
      <div className="min-h-[100dvh] bg-gray-50 overflow-hidden">
        <Toaster />
        <div className="max-w-[768px] mx-auto relative">
          <AnimatePresence>
            {isSideBar && (
              <>
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 0.5 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.3 }}
                  className="fixed inset-0 bg-black z-50 "
                  onClick={() => setIsSideBar(false)}
                />
                <motion.div
                  initial={{ x: -300, opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  exit={{ x: -300, opacity: 0 }}
                  transition={{
                    type: "spring",
                    stiffness: 100,
                    damping: 20,
                    duration: 0.3,
                  }}
                  className="absolute w-80 h-full overflow-hidden overflow-y-auto z-50 bg-white"
                >
                  <Sidebar
                    onHide={() => setIsSideBar(false)}
                    page={"Day Close Cash"}
                  />
                </motion.div>
              </>
            )}
          </AnimatePresence>

          <div className="bg-[#F3F3F3] rounded-3xl overflow-y-auto shadow-sm p-4 h-[100dvh]">
            <NavBar onSideBar={() => setIsSideBar(true)} />
            <div className="flex justify-between items-center mb-4">
              <div className="relative inline-block ">
                <div
                  className="
                                      bg-white/90 backdrop-blur-sm rounded-lg px-4 py-2 border border-indigo-100
                                      shadow-sm shadow-indigo-100
                                      transition-all duration-300
                                      overflow-hidden
                                  "
                >
                  <h1
                    className="
                                      text-sm 
                                      text-indigo-600
                                      relative z-10
                                      transition-all duration-300
                                      font-QBold
                                      "
                  >
                    Day Close Cash Difference
                  </h1>
                </div>
              </div>
              {/* <button
                onClick={() => setIsFilterOpen(true)}
                className="flex items-center gap-1 bg-indigo-100 rounded-[8px] px-3 py-2 shadow-sm hover:bg-indigo-200 transition-colors"
              >
                <i className="ri-filter-line text-indigo-600"></i>
                <span className="text-sm font-QSemiBold text-indigo-700">
                  Filter
                </span>
              </button> */}
            </div>

            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
              {/* Search Bar */}

              {/* Location Selector */}
              {adminInfo?.multiple_location &&
              adminInfo.multiple_location.length > 0 ? (
                <button
                  onClick={() => setIsLocationModalOpen(true)}
                  className="px-4 py-2.5 flex items-center gap-x-2 bg-indigo-700 rounded-xl text-white text-sm font-QMedium tracking-tight whitespace-nowrap shadow-sm hover:bg-indigo-800 transition"
                >
                  Locations
                  <img src={down} className="w-4 h-4" alt="" />
                </button>
              ) : (
                <LocationDropdown
                  dropdownRef={dropdownRef}
                  isDropdownOpen={isDropdownOpen}
                  setIsDropdownOpen={setIsDropdownOpen}
                  filterLocations={filterLocations}
                  locations={locationData}
                  toggleLocationSelection={toggleLocationSelection}
                  getDisplayText={getDisplayText}
                  onApply={() => {
                    if (!validateDateRange()) return;
                    refetch();
                  }}
                />
              )}
            </div>

            <div className="flex max-[640px]:flex-col justify-between gap-2 mb-4">
              <div className="w-[50%] max-[640px]:w-full">
                <DatePickerWithInput
                  label="From Date"
                  value={fromDate}
                  onChange={setFromDate}
                />
              </div>
              <div className="w-[50%] max-[640px]:w-full">
                <DatePickerWithInput
                  label="To Date"
                  value={toDate}
                  onChange={setToDate}
                />
              </div>
            </div>

            {/* <div>
              <FilterPopup
                ref={filterRef}
                isOpen={isFilterOpen}
                onClose={() => setIsFilterOpen(false)}
                fromDate={fromDate}
                setFromDate={setFromDate}
                toDate={toDate}
                setToDate={setToDate}
                locations={locationDatas}
                selectedLocations={filterLocations}
                toggleLocationSelection={toggleLocationSelection}
                getDisplayText={getDisplayText}
                onReset={handleResetFilter}
                onApply={handleApplyFilter}
              />
            </div> */}

            {/* Replace your grid section with this */}
            <AnimatePresence mode="wait">
              {/* Loading State */}
              {isLoading && (
                <motion.div
                  key="loading"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  className="grid grid-cols-1 sm:grid-cols-2 gap-4"
                >
                  {[...Array(4)].map((_, i) => (
                    <div
                      key={i}
                      className="bg-white border border-gray-200 rounded-2xl p-5 flex flex-col gap-3"
                    >
                      {/* Top Row Skeleton */}
                      <div className="flex items-start gap-3">
                        <div className="w-10 h-10 rounded-xl bg-gray-100 animate-pulse flex-shrink-0" />
                        <div className="flex-1 flex flex-col gap-2">
                          <div className="h-3.5 bg-gray-100 animate-pulse rounded-full w-4/5" />
                          <div className="h-3 bg-gray-100 animate-pulse rounded-full w-2/5" />
                        </div>
                      </div>
                      {/* Badges Skeleton */}
                      <div className="flex gap-2">
                        <div className="h-6 w-20 bg-gray-100 animate-pulse rounded-full" />
                        <div className="h-6 w-16 bg-gray-100 animate-pulse rounded-full" />
                      </div>
                      {/* Price Skeleton */}
                      <div className="flex gap-6 border-t border-gray-100 pt-3">
                        <div className="flex flex-col gap-1">
                          <div className="h-2.5 w-8 bg-gray-100 animate-pulse rounded-full" />
                          <div className="h-3.5 w-12 bg-gray-100 animate-pulse rounded-full" />
                        </div>
                        <div className="flex flex-col gap-1">
                          <div className="h-2.5 w-8 bg-gray-100 animate-pulse rounded-full" />
                          <div className="h-3.5 w-12 bg-gray-100 animate-pulse rounded-full" />
                        </div>
                        <div className="flex flex-col gap-1 ml-auto items-end">
                          <div className="h-2.5 w-14 bg-gray-100 animate-pulse rounded-full" />
                          <div className="h-3.5 w-12 bg-gray-100 animate-pulse rounded-full" />
                        </div>
                      </div>
                    </div>
                  ))}
                </motion.div>
              )}

              {/* Empty State */}
              {!isLoading &&
                !isFetching &&
                isFetched &&
                (!dayCloseCashData || dayCloseCashData.length === 0) && (
                  <motion.div
                    key="empty"
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    className="flex flex-col items-center justify-center py-16 gap-4"
                  >
                    <div className="w-16 h-16 rounded-2xl bg-gray-50 border border-gray-200 flex items-center justify-center">
                      <svg
                        width="28"
                        height="28"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#d1d5db"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M8 3h8l1 7c0 3.3-2.2 6-5 6s-5-2.7-5-6l1-7z" />
                        <line x1="12" y1="16" x2="12" y2="21" />
                        <line x1="9" y1="21" x2="15" y2="21" />
                      </svg>
                    </div>
                    <div className="text-center">
                      <p className="text-sm font-QSemiBold text-gray-500">
                        No products found
                      </p>
                      <p className="text-xs text-gray-400 mt-1 font-QMedium">
                        Try adjusting your search or filters
                      </p>
                    </div>
                  </motion.div>
                )}

              {/* Product Grid */}
              {!isLoading &&
                dayCloseCashData &&
                dayCloseCashData.length > 0 && (
                  <motion.div
                    key="grid"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    className="grid grid-cols-1 sm:grid-cols-2 gap-4"
                  >
                    {dayCloseCashData.map((p, i) => {
                      const isPositive = p.cashDiff >= 0;
                      return (
                        <motion.div
                          key={i}
                          initial={{ opacity: 0, y: 12 }}
                          animate={{ opacity: 1, y: 0 }}
                          transition={{
                            delay: i * 0.05,
                            type: "spring",
                            stiffness: 280,
                            damping: 24,
                          }}
                          className="bg-white border border-gray-200 rounded-2xl p-5 flex flex-col gap-3 hover:border-gray-400 hover:shadow-sm transition-all duration-200 cursor-default"
                        >
                          {/* Top Row */}
                          <div className="flex items-start gap-3">
                            <div className="w-10 h-10 rounded-xl bg-indigo-50 flex items-center justify-center flex-shrink-0">
                              <svg
                                width="18"
                                height="18"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="#4338ca"
                                strokeWidth="1.8"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              >
                                <rect
                                  x="2"
                                  y="6"
                                  width="20"
                                  height="12"
                                  rx="2"
                                />
                                <path d="M2 10h20" />
                                <path d="M6 14h4" />
                              </svg>
                            </div>
                            <div className="flex-1 min-w-0">
                              <p className="text-sm font-QSemiBold text-gray-900 leading-snug">
                                {p.locationName} · {p.counterName}
                              </p>
                              <p className="text-xs font-QMedium text-gray-400 mt-1 tracking-wider">
                                {p.cashierName} · Counter {p.counterNo}
                              </p>
                            </div>
                          </div>

                          {/* Badges */}
                          <div className="flex gap-2 flex-wrap">
                            <span className="text-xs font-QMedium px-2.5 py-1 rounded-full bg-indigo-50 text-indigo-700 border border-indigo-200">
                              {new Date(p.dayClose).toLocaleDateString(
                                undefined,
                                {
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric",
                                },
                              )}
                            </span>
                            <span className="text-xs font-QMedium px-2.5 py-1 rounded-full bg-gray-50 text-gray-500 border border-gray-200">
                              {new Date(p.dayClose).toLocaleTimeString(
                                undefined,
                                {
                                  hour: "2-digit",
                                  minute: "2-digit",
                                },
                              )}
                            </span>
                          </div>

                          {/* Cash Row */}
                          <div className="flex gap-6 border-t border-gray-100 pt-3">
                            <div className="flex flex-col gap-0.5">
                              <span className="text-xs uppercase tracking-widest text-gray-400 font-QSemiBold">
                                System Cash
                              </span>
                              <span className="text-xs font-QMedium">
                                {fmt(p.systemCash)}
                              </span>
                            </div>
                            <div className="flex flex-col gap-0.5">
                              <span className="text-xs uppercase tracking-widest text-gray-400 font-QSemiBold">
                                Physical Cash
                              </span>
                              <span className="text-xs font-QMedium">
                                {fmt(p.physicalCash)}
                              </span>
                            </div>
                            <div className="flex flex-col gap-0.5 ml-auto text-right">
                              <span className="text-xs uppercase tracking-widest text-gray-400 font-QSemiBold">
                                Diff
                              </span>
                              <span
                                className={`text-xs font-QSemiBold ${
                                  isPositive
                                    ? "text-emerald-600"
                                    : "text-red-500"
                                }`}
                              >
                                {isPositive ? "+" : ""}
                                {fmt(p.cashDiff)}
                              </span>
                            </div>
                          </div>
                        </motion.div>
                      );
                    })}
                  </motion.div>
                )}
            </AnimatePresence>

            <div className="h-20"></div>

            {/* Bottom Nav */}
            <CommonFooter page={""} />
          </div>
        </div>
        <MultipleLocationSuperMarketModal
          isOpen={isLocationModalOpen}
          fromDate={fromDate}
          toDate={toDate}
          onClose={() => setIsLocationModalOpen(false)}
          onDataSubmit={handleLocationSubmit}
          dataUrl={"Sales/DepartmentwiseAmount"}
          onPendingChange={setPending}
        />
      </div>
      <AIAssistant />
    </>
  );
};

export default DayCloseCash;
